'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils_functional_compose = require('../functional/compose.js');
var utils_string_removeAccents = require('./removeAccents.js');

var sanitize = utils_functional_compose['default'](utils_string_removeAccents['default'], function (str) {
  return str.toLowerCase();
});

exports.default = sanitize;
//# sourceMappingURL=sanitize.js.map
